import React from 'react';
import { Box, Pagination as MuiPagination } from '@mui/material';

interface PaginationProps {
  currentPage: number;
  totalPages: number;
  onPageChange: (page: number) => void;
}

const Pagination: React.FC<PaginationProps> = ({
  currentPage,
  totalPages,
  onPageChange,
}) => {
  const handlePageChange = (_event: React.ChangeEvent<unknown>, page: number) => {
    onPageChange(page);
  };

  // Don't render pagination if there's only one page
  if (totalPages <= 1) {
    return null;
  }

  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        mt: 4,
        mb: 2,
        flexDirection: 'column',
        gap: 2,
      }}
    >
      {/* Pagination component */}
      <MuiPagination
        count={totalPages}
        page={currentPage}
        onChange={handlePageChange}
        color="standard"
        size="large"
        showFirstButton
        showLastButton
        sx={{
          '& .MuiPaginationItem-root': {
            color: '#B3907A',
            border: '1px solid transparent',
            '&:hover': {
              backgroundColor: '#B3907A',
              color: 'white',
              border: '1px solid #B3907A',
            },
          },
          '& .Mui-selected': {
            backgroundColor: '#B3907A !important',
            color: 'white !important',
            border: '1px solid #B3907A !important',
            '&:hover': {
              backgroundColor: '#B3907A !important',
              color: 'white !important',
              border: '1px solid #B3907A !important',
            },
          },
          '& .MuiPaginationItem-ellipsis': {
            color: '#B3907A',
          },
        }}
      />
    </Box>
  );
};

export default Pagination;
